import { render, staticRenderFns } from "./PointRow.vue?vue&type=template&id=67eae1e0&scoped=true&"
import script from "./PointRow.vue?vue&type=script&lang=js&"
export * from "./PointRow.vue?vue&type=script&lang=js&"
import style0 from "./PointRow.vue?vue&type=style&index=0&id=67eae1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eae1e0",
  null
  
)

export default component.exports